import { mapState } from 'vuex';
import { getlocalStorageToken } from '../utils/auth';

export const AuthCheckMixin = {
    computed: {
        ...mapState({
            auth: state => state.auth.item,
        }),

        loginChk() {
            let token = getlocalStorageToken();
            return ( token !=null && token != '' && this.auth && this.auth.id > 0)
        },

        agentCheck(){
            var userAgent = window.navigator.userAgent;
            let apple = 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_10_4) AppleWebKit/600.7.12 (KHTML, like Gecko) Version/8.0.7 Safari/600.7.12';
            var ret = 'other';
            // 안드로이드
            if( /Android|prebook_android/i.test(userAgent)) { 
                ret = 'android';
            }
            // iOS 아이폰, 아이패드, 아이팟
            // else if (/iPhone|iPad|iPod|apple/i.test(userAgent)) {  
            else if (apple.includes(userAgent)) {  
                ret = 'ios';
            }
            // 그 외 디바이스 
            return ret; 
        }
    },

    methods: {
        socialCheck(socialCd) {
            return (
                this.auth.social && 
                this.auth.social.linkCd == socialCd
            );
        },

        authBookingAlarmCheck(){
            if(this.auth.id > 0) {
                this.$store.dispatch('GET_ALARM_COUNT')
                .then((data) => {
                    this.$store.commit('SET_AUTH_BOOKING_ALARM_COUNT', data.content);
                });
            } 
        },
    },
};